import { connect } from 'react-redux';
import * as actions from '../../actions/discipline';
import Disciplines from '../../components/disciplines/Disciplines';

const mapStateToProps = ({ discipline }) => ({
  disciplines: discipline.disciplines,
  isLoading: discipline.isLoading,
});

const mapDispatchToProps = dispatch => ({
  fetchAllDisciplines: () => dispatch(actions.allDisciplines()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Disciplines);
